// extracted by mini-css-extract-plugin
module.exports = {"card_container":"BrandCard_card_container__xJLp9","card_action_area":"BrandCard_card_action_area__OV_q2","name":"BrandCard_name__MnVPH","icon":"BrandCard_icon__OYyOe"};